import findNextNode from './find-next-node';
import findFirstTextNode from './find-first-text-node';

const findNextTextContent = (element, relativeParentElement) => {
  let nextElement = findNextNode(element, relativeParentElement);
  let targetNode = null;

  while (nextElement && !targetNode) {
    targetNode = findFirstTextNode(nextElement, true);
    nextElement = findNextNode(nextElement, relativeParentElement);
  }

  return targetNode;
};

export default findNextTextContent;
